import { produce } from "immer";
import * as Actions from "./savedSearchesActions";

import deepmerge from "deepmerge";
import combineMerge from "config/combineMerge";

const initialState = { byId: {}, allIds: [] };
const savedSearchesReducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.FETCH_SAVED_SEARCHES_SUCCESS: {
      const payload = action.payload;
      const savedSearches = payload.savedSearches.map(item => ({
        ...item,
        deleted: false
      }));
      const savedSearchIds = payload.savedSearches.map(
        savedSearch => savedSearch.id
      );

      const byId = savedSearches.reduce((obj, savedSearch) => {
        obj[savedSearch.id] = savedSearch;
        return obj;
      }, {});

      draft.byId = deepmerge(draft.byId, byId, {
        arrayMerge: combineMerge
      });
      draft.allIds = savedSearchIds;

      break;
    }
    case Actions.DELETE_ITEM: {
      const { id } = action.payload;
      delete draft.byId[id];

      break;
    }
    default:
      return draft;
  }
}, initialState);

export default savedSearchesReducer;
